<template>
  <div
    class="
      group relative flex h-full flex-col overflow-hidden rounded-tl-[2.5rem] bg-grey-100 transition-colors
      ease-in-out
      hover-focus:bg-grey-200
      sm:rounded-tl-[3.5rem]
    "
  >
    <!-- IMAGE -->
    <div class="w-full overflow-hidden" :class="isFirst ? 'aspect-[529/273]' : 'aspect-[327/221]'">
      <AppImage
        v-if="data.image"
        class="
          size-full object-cover transition-transform duration-200 ease-in-out
          group-hover-focus:scale-105
        "
        :src="data.image"
        :alt="useMapAltText(data.image)"
      />
    </div>

    <!-- CATEGORY -->
    <div
      v-if="data.category"
      class="absolute right-[1.375rem] top-5 w-fit border px-2 py-1 typo-body-lg"
      :class="data.image ? 'border-white text-white': 'border-dark text-dark'"
    >
      {{ data.category?.title }}
    </div>

    <!-- TEXT -->
    <div class="flex grow flex-col justify-between px-8 pb-6">
      <!-- Title -->
      <h3
        class="line-clamp-5 font-semibold"
        :class="data.image ? 'pt-5 typo-heading-sm sm:pt-6 sm:typo-heading-md' : `
          -translate-y-5 typo-heading-lg
          sm:typo-heading-xl
        `"
      >
        {{ data.heading }}
      </h3>

      <div class="mt-auto flex flex-wrap items-center justify-between gap-x-3 gap-y-2 pt-7 sm:pt-9">
        <!-- Date -->
        <time class="typo-body-lg" :datetime="data.date">{{ dateFormatted }}</time>
        <!-- Link -->
        <AppLink
          use-simple-arrow
          :to="{ path: data.url, query: $route.query }"
          class="select-none !typo-body-lg after:absolute after:inset-0 after:z-10"
        >
          {{ $t('learn_more') }}
        </AppLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { BlogArticleFragment } from '#gql'

const props = defineProps<{
  data: Enforce<BlogArticleFragment>
  isFirst?: boolean
}>()

const dateFormatted = useDateFormatted(props.data, {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
})
</script>
